import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = {
  class: "p-field-label",
  for: "guestsurname"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ElScrollbar, { class: "details-panel-content" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(`${_ctx.$t("AppResourceEP.Description")} (${_ctx.$t("AppResource.Max")} ${_ctx.descriptionMaxLength} ${_ctx.$t("AppResourceEP.Characters")})`), 1),
          _createVNode(_component_InputText, {
            disabled: _ctx.disabled,
            id: "guestsurname",
            type: "text",
            class: ["w-50", { 'input-error': !_ctx.valid, 'w-100': !_ctx.isEdit }],
            modelValue: _ctx.editingGuest.description,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingGuest.description = $event)),
              _ctx.guestWasEdited
            ],
            maxlength: _ctx.descriptionMaxLength
          }, null, 8, ["disabled", "modelValue", "maxlength", "class", "onUpdate:modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}